"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterTransaction = void 0;
const consts_1 = require("../../consts");
const u_1 = require("../../u");
const core_1 = require("../../wallet/core");
const BaseTransaction_1 = require("./BaseTransaction");
const TransactionType_1 = __importDefault(require("./TransactionType"));
class RegisterTransaction extends BaseTransaction_1.BaseTransaction {
    constructor(obj = {}) {
        super(Object.assign({ version: consts_1.TX_VERSION.REGISTER }, obj));
        this.type = TransactionType_1.default.RegisterTransaction;
        this.assetType = obj.assetType || 0;
        this.name = obj.name || "";
        this.amount = new u_1.Fixed8(obj.amount);
        this.precision = obj.precision || 0;
        this.owner = obj.owner || "";
        this.admin = obj.admin || "";
    }
    static deserializeExclusive(ss, tx) {
        const assetType = parseInt(u_1.reverseHex(ss.read(1)), 16);
        const name = u_1.hexstring2str(ss.readVarBytes());
        const amount = u_1.fixed82num(ss.read(8));
        const precision = parseInt(u_1.reverseHex(ss.read(1)), 16);
        // TODO: extract a method to get the publicKey. Refactor both
        // enrollment transaction and register transaction
        const hexStrPrefix = ss.read(1);
        const prefix = parseInt(hexStrPrefix, 16);
        let pKey = "";
        let owner = "";
        // Compressed public keys.
        if (prefix === 0x02 || prefix === 0x03) {
            pKey = ss.read(32);
        }
        else if (prefix === 0x04) {
            pKey = ss.read(64);
        }
        else if (prefix === 0x00) {
            // do nothing, For infinity, the p.Key == 0x00, included in the prefix
        }
        else {
            throw new Error("Prefix not recognised for public key");
        }
        if (pKey !== "") {
            pKey = hexStrPrefix + pKey;
            owner = core_1.getPublicKeyUnencoded(pKey);
        }
        const admin = u_1.reverseHex(ss.read(20));
        return Object.assign(tx, {
            assetType,
            name,
            amount,
            precision,
            owner,
            admin,
        });
    }
    get exclusiveData() {
        return {
            assetType: this.assetType,
            name: this.name,
            amount: this.amount,
            precision: this.precision,
            owner: this.owner,
            admin: this.admin,
        };
    }
    get fees() {
        if (this.assetType === consts_1.ASSET_TYPE.GoverningToken ||
            this.assetType === consts_1.ASSET_TYPE.UtilityToken) {
            return 0;
        }
        return consts_1.DEFAULT_SYSFEE.registerTransaction;
    }
    serializeExclusive() {
        let out = u_1.num2hexstring(this.assetType, 1, true);
        out += u_1.num2VarInt(this.name.length);
        out += u_1.str2hexstring(this.name);
        out += this.amount.toReverseHex();
        out += u_1.num2hexstring(this.precision, 1, true);
        out += core_1.getPublicKeyEncoded(this.owner);
        out += u_1.reverseHex(this.admin);
        return out;
    }
    export() {
        return Object.assign(super.export(), {
            assetType: this.assetType,
            name: this.name,
            amount: this.amount.toNumber(),
            precision: this.precision,
            owner: this.owner,
            admin: this.admin,
        });
    }
    equals(other) {
        if (this.type !== other.type) {
            return false;
        }
        if (other instanceof RegisterTransaction) {
            return this.hash === other.hash;
        }
        return this.hash === new RegisterTransaction(other).hash;
    }
}
exports.RegisterTransaction = RegisterTransaction;
exports.default = RegisterTransaction;
